var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("\n        Submittal Information\n    ")]),_vm._v(" "),_c('p',{staticClass:"info"},[_vm._v("Notes will be displayed near the submittal stamp on each product information page.")])])
}]

export { render, staticRenderFns }